/* Skapad av Claude Code — Startsida-quiz (förgrenad nodgraf, 2 spår à 4 frågor).
   Källa: godkänd preview lp-studio/arbetsfiler/startsida/startsida-preview.html.
   Produkter/URL:er hårdkodade i v1 enligt Erik-mönstret för LP:er.
   Öppnas från alla [data-quiz-open]-knappar (hero, behovsbanner, botten-CTA). */
(function () {
  'use strict';
  if (window.__svdStartsidaQuiz) return;
  window.__svdStartsidaQuiz = true;

  var PRODUCTS = {
    magbalans:  { name: 'Magbalans',          why: 'Prebiotika som stödjer en stabil mage och tarm.',        price: '329 kr', url: 'https://svensktdjurtillskott.se/products/magbalans-for-hundens-mage-tarm', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/Svenskt_Djurtillskott_Product_Magbalans_150_g_2025.06.25_1.jpg?v=1769078446&width=300' },
    hudpals:    { name: 'Hud och Päls',        why: 'Omega-3-olja för friskare hud och glansigare päls.',     price: '289 kr', url: 'https://svensktdjurtillskott.se/products/hud-och-pals-500ml', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/Svenskt_Djurtillskott_Product_Hud_och_Pals_500_g_2025.06.25_1.jpg?v=1750846011&width=300' },
    smile:      { name: 'SMILE+',              why: 'Pulver för munhälsa och fräschare andedräkt.',           price: '289 kr', url: 'https://svensktdjurtillskott.se/products/smile', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/Svenskt_Djurtillskott_Product_Smile_100_g_2025.06.25_1.jpg?v=1766868257&width=300' },
    vardag:     { name: 'Vardag+',             why: 'Magnesium och tryptofan för hundar som varvar upp.',     price: '279 kr', url: 'https://svensktdjurtillskott.se/products/vardag-magnesium-och-tryptofan', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/Svenskt_Djurtillskott_Product_Calma_150_g_2025.06.25_1.jpg?v=1767027473&width=300' },
    tassalva:   { name: 'Tassalva',            why: 'Skyddar och mjukgör torra, känsliga tassar.',            price: '279 kr', url: 'https://svensktdjurtillskott.se/products/tassalva', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/SvensktDjurtillskott_Product_Tassalva_2025.06.28_1.jpg?v=1751143298&width=300' },
    slowfeeder: { name: 'Bloom Slow Feeder',   why: 'Saktar ner måltiden och gör den lugnare.',               price: '199 kr', url: 'https://svensktdjurtillskott.se/products/bloom-slow-feeder', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/Slow_Feeder_Bloom_2_121eccb6-cd44-4dda-b20f-97b401693a9b.jpg?v=1781641927&width=300' },
    flaska:     { name: '3-i-1 Vattenflaska',  why: 'Vatten, mat och skål på alla era äventyr.',              price: '399 kr', url: 'https://svensktdjurtillskott.se/products/3-i-1-vattenflaska-for-hundar', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/SvD_3-i-1_Vattenflaska_18.jpg?v=1749627209&width=300' },
    tjurmuskel: { name: 'Tjurmuskelbitar',     why: 'Naturligt långtugg av 100 % svensk råvara.',             price: '99 kr',  url: 'https://svensktdjurtillskott.se/products/tjurmuskelbitar-100g', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/Svenskt_Djurtillskott_Tjurmuskelbitar_1.jpg?v=1756148307&width=300' },
    grisoron:   { name: 'Grisöron 10-pack',    why: 'Klassiskt tugg av 100 % svenska råvaror.',               price: '239 kr', url: 'https://svensktdjurtillskott.se/products/grisoron-10-pack', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/Svenskt_Djurtillskott_Grisoron_1.jpg?v=1763671383&width=300' },
    notlunga:   { name: 'Nötlunga',            why: 'Små belöningsbitar, perfekta vid träning.',              price: '89 kr',  url: 'https://svensktdjurtillskott.se/products/notlunga-80g', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/Svenskt_Djurtillskott_Notlunga_1.jpg?v=1756148286&width=300' },
    vatske:     { name: 'Vätskeersättning',    why: 'Elektrolyter för återhämtning varma och aktiva dagar.', price: '199 kr', url: 'https://svensktdjurtillskott.se/products/vatskeersattning-hund-200g', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/Svenskt_Djurtillskott_Product_Vatskeersattning_200_g_2025.06.25_1.jpg?v=1750846130&width=300' },
    isform:     { name: 'Isform Hund',         why: 'Gör egna frysta treats, sex tassar och två ben.',        price: '59 kr',  url: 'https://svensktdjurtillskott.se/products/isform-hund-gor-dina-egna-frysta-hund-treats', img: 'https://cdn.shopify.com/s/files/1/0812/6208/4429/files/Isformhund1.png?v=1782915265&width=300' }
  };

  /* Två spår: tillskott (besvär) och godis/tillbehör. 4 frågor per spår. */
  var NODES = {
    start: { q: 'Har din hund besvär?', opts: [
      { label: 'Ja, med magen', hint: 'Äter gräs, lös eller orolig mage', next: 'mage' },
      { label: 'Ja, med hud, päls eller tassar', hint: 'Klåda, mjäll eller torra tassar', next: 'hud' },
      { label: 'Ja, med munnen eller tänderna', hint: 'Dålig andedräkt eller beläggningar', next: 'mun' },
      { label: 'Ja, med oro eller stress', hint: 'Ljudkänslig eller varvar upp lätt', next: 'oro' },
      { label: 'Nej, jag letar efter hundgodis och tillbehör', next: 'godis1' }
    ]},

    mage: { q: 'Vad känner du igen hos din hund?', opts: [
      { label: 'Äter gräs eller slickar på saker', pick: ['magbalans'], next: 'testat' },
      { label: 'Lös eller ojämn mage', pick: ['magbalans'], next: 'testat' },
      { label: 'Gaser och kurrande mage', pick: ['magbalans'], next: 'testat' }
    ]},
    hud: { q: 'Vad stämmer bäst?', opts: [
      { label: 'Kliar sig ofta', pick: ['hudpals'], next: 'testat' },
      { label: 'Torr hud, mjäll eller matt päls', pick: ['hudpals'], next: 'testat' },
      { label: 'Torra eller spruckna tassar', pick: ['tassalva'], next: 'testat' }
    ]},
    mun: { q: 'Vad stämmer bäst?', opts: [
      { label: 'Dålig andedräkt', pick: ['smile'], next: 'testat' },
      { label: 'Beläggningar eller tandsten', pick: ['smile'], next: 'testat' },
      { label: 'Både och', pick: ['smile'], next: 'testat' }
    ]},
    oro: { q: 'I vilka situationer märks det?', opts: [
      { label: 'Höga ljud, åska eller fyrverkerier', pick: ['vardag'], next: 'testat' },
      { label: 'Vid ensamhet', pick: ['vardag'], next: 'testat' },
      { label: 'Allmänt uppvarvad i vardagen', pick: ['vardag'], next: 'testat' }
    ]},
    testat: { q: 'Har du testat tillskott för det här tidigare?', opts: [
      { label: 'Ja, utan större effekt', note: 'testat', next: 'extra' },
      { label: 'Ja, med viss effekt', next: 'extra' },
      { label: 'Nej, det här är första gången', next: 'extra' }
    ]},
    extra: { q: 'Känner du igen något mer?', opts: [
      { label: 'Slukar maten på några sekunder', pick: ['slowfeeder'], next: 'result' },
      { label: 'Dricker dåligt på promenader och resor', pick: ['flaska'], next: 'result' },
      { label: 'Torra tassar vissa perioder', pick: ['tassalva'], next: 'result' },
      { label: 'Dålig andedräkt', pick: ['smile'], next: 'result' },
      { label: 'Älskar att tugga', pick: ['tjurmuskel'], next: 'result' },
      { label: 'Behöver extra vätska varma dagar', pick: ['vatske'], next: 'result' },
      { label: 'Nej, det var allt', next: 'result' }
    ]},

    godis1: { q: 'Vad letar du efter?', opts: [
      { label: 'Tuggben och långtugg', pick: ['tjurmuskel', 'grisoron'], next: 'godis2' },
      { label: 'Belöningsgodis för träning', pick: ['notlunga'], next: 'godis2' },
      { label: 'Tillbehör för måltider och vardag', pick: ['slowfeeder', 'isform'], next: 'godis2' }
    ]},
    godis2: { q: 'Prioriterar du svenskt tillverkat?', opts: [
      { label: 'Ja, det är viktigt för mig', note: 'svenskt', next: 'godis3' },
      { label: 'Inte avgörande', next: 'godis3' }
    ]},
    godis3: { q: 'Är ni ofta ute på långa promenader eller utflykter?', opts: [
      { label: 'Ja, ofta', pick: ['flaska'], next: 'result' },
      { label: 'Ja, även varma sommardagar', pick: ['flaska', 'vatske'], next: 'result' },
      { label: 'Ibland', next: 'result' },
      { label: 'Mest hemma och i närområdet', pick: ['isform'], next: 'result' }
    ]}
  };
  var TOTAL_STEPS = 4;

  var overlay = document.getElementById('sh-quiz');
  var body = document.getElementById('sh-quiz-body');
  if (!overlay || !body) return;

  var current = 'start';
  var picks = [];
  var notes = [];
  var history = [];

  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;'); }

  function progress(step) {
    var html = '<div class="sh-quiz-progress">';
    for (var i = 0; i < TOTAL_STEPS; i++) {
      html += '<span class="' + (i < step ? 'is-done' : '') + '"></span>';
    }
    return html + '</div>';
  }

  function renderNode() {
    var node = NODES[current];
    var step = history.length;
    var html = progress(step);
    html += '<div class="sh-quiz-step">Fråga ' + (step + 1) + ' av ' + TOTAL_STEPS + '</div>';
    html += '<h3>' + esc(node.q) + '</h3>';
    html += '<div class="sh-quiz-options">';
    node.opts.forEach(function (o, i) {
      html += '<button class="sh-quiz-opt" type="button" data-opt="' + i + '">' + esc(o.label);
      if (o.hint) html += '<small>' + esc(o.hint) + '</small>';
      html += '</button>';
    });
    html += '</div>';
    if (step > 0) html += '<button class="sh-quiz-back" type="button" data-back>Tillbaka</button>';
    body.innerHTML = html;
    body.querySelectorAll('[data-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var opt = node.opts[Number(btn.getAttribute('data-opt'))];
        history.push({ node: current, picks: picks.slice(), notes: notes.slice() });
        if (opt.pick) opt.pick.forEach(function (k) { if (picks.indexOf(k) === -1) picks.push(k); });
        if (opt.note) notes.push(opt.note);
        if (opt.next === 'result') renderResult();
        else { current = opt.next; renderNode(); }
      });
    });
    var back = body.querySelector('[data-back]');
    if (back) back.addEventListener('click', function () {
      var prev = history.pop();
      current = prev.node; picks = prev.picks; notes = prev.notes;
      renderNode();
    });
  }

  function renderResult() {
    var recs = picks.slice(0, 4);
    if (!recs.length) recs = ['magbalans', 'tjurmuskel'];
    var sub = 'Baserat på dina svar tror vi att din hund skulle må bra av det här.';
    if (notes.indexOf('testat') !== -1) {
      sub = 'Många hittar till oss efter att ha testat annat. Våra tillskott utvecklas och tillverkas i Sverige, med noggrant utvalda råvaror.';
    } else if (notes.indexOf('svenskt') !== -1) {
      sub = 'Bra val. Det här tillverkas i Sverige av svenska råvaror.';
    }
    var html = '<h3>Här är produkterna som passar er</h3>';
    html += '<p class="sh-quiz-result-sub">' + sub + '</p>';
    html += '<div class="sh-quiz-recs">';
    recs.forEach(function (key) {
      var p = PRODUCTS[key];
      html += '<a class="sh-quiz-rec" href="' + p.url + '">'
        + '<span class="sh-quiz-rec-img"><img src="' + p.img + '" alt="' + esc(p.name) + '" loading="lazy"></span>'
        + '<span class="sh-quiz-rec-txt"><span class="sh-quiz-rec-name">' + esc(p.name) + '</span>'
        + '<span class="sh-quiz-rec-why">' + esc(p.why) + '</span></span>'
        + '<span class="sh-quiz-rec-right"><span class="sh-quiz-rec-price">' + p.price + '</span>'
        + '<span class="sh-btn sh-quiz-rec-btn">Läs mer</span></span>'
        + '</a>';
    });
    html += '</div>';
    html += '<div class="sh-quiz-actions"><button class="sh-btn sh-btn-sm sh-btn-ghost" type="button" data-restart>Gör om quizet</button></div>';
    body.innerHTML = html;
    body.querySelector('[data-restart]').addEventListener('click', reset);
  }

  function reset() { current = 'start'; picks = []; notes = []; history = []; renderNode(); }

  function open() { reset(); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function close() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

  /* Delegering: quiz-öppnare finns i flera sektioner (hero, behov, botten-CTA)
     och kan re-renderas i temaredigeraren. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quiz-open]')) { open(); return; }
    if (e.target.closest('[data-quiz-close]')) { close(); return; }
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });
})();
